import { application } from '../application'

import TagifyController from './tagify_controller'
application.register('tagify', TagifyController)
